<template>
  <div class="one-to-three">
    <div class="header" style="margin-top: .04rem;">
      <div>{{floorData.floorTitle}}</div>
      <a v-if="floorData.isMore === '0'" class="more" :href="!$isIframe ? floorData.moreUrl: 'javascript:void(0);'">
        <span>更多</span>
        <img src="@/assets/img/arrow-right.png" />
      </a>
    </div>
    <div class="content">
        <div class="one-pic">
            <a @click="$jumpToPage(floorData.data[0])">
                <img :src="floorData.data[0].imageUrl" />
            </a>
        </div>
        <div v-if="threeGrids.length > 0" class="three-pics">
            <div v-for="(item, idx) in threeGrids" :key="idx" class="box-item">
                <a @click='$jumpToPage(item)' >
                    <img class="item-img" :src="item.imageUrl" />
                    <span class="item-title">{{item.title}}</span>
                    <span class="item-second-title">{{item.subtitleFirst}}</span>
                </a>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'OneToThree',
  props: ['floorData'],
  computed: {
    threeGrids () {
      return this.floorData.data.length > 0 ? this.floorData.data.slice(1) : []
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .one-to-three{
    padding: 0 0.1rem;
    .content{
        overflow: hidden;
        .one-pic{
            height: .9rem;
            img{
                height: 100%;
                width: 100%;
                border-radius: 5px;
            }
        }
        .three-pics{
            height: 1.38rem;
            margin-top: .12rem;
            display: flex;
            // justify-content: space-between;
            .box-item{
                height: 100%;
                width: 1.13rem;
                margin-right: .08rem;
                a{
                    display: flex;
                    height: 100%;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                     .item-img{
                        width: .85rem;
                        height: .85rem;
                        border-radius: 20px;
                    }
                    .item-title{
                       color: #000;
                        height: .2rem;
                        line-height: .2rem;
                        font-size: .14rem;
                        font-family: PingFangSC, PingFangSC-Regular;
                    }
                    .item-second-title{
                        color: #888888;
                        font-size: .11rem;
                        font-family: PingFangSC, PingFangSC-Regular;
                        margin-bottom: 2px;
                    }
                }
            }
            .box-item:last-child{
              margin-right: 0;
            }
        }
    }
  }
</style>
